var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'files-readonly': !_vm.canManageFiles }},[_c('heading',{attrs:{"helpInfo":_vm.sidebarCard}},[_vm._v(_vm._s(_vm.$t("sidebar.files")))]),_c('file-browser',{attrs:{"endpoints":_vm.endpoints,"axiosConfig":_vm.axiosConfig,"maxUploadFileSize":524288000,"maxUploadFilesCount":500}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }